<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->

<template>
  <div v-if="show">
    <vue-plotly :data="plotData" :layout="layout" :options="options" class="pa-0 ma-0" />
  </div>
  <div v-else class="align-center">
    <v-img
      class="align-center"
      max-height="100"
      max-width="65"
      src="/reo_pics/error.png"
    ></v-img>
  </div>
</template>

<script>
  import VuePlotly from '@statnett/vue-plotly';
  import {mapGetters} from 'vuex';
  import {config} from '@/store/config';

  export default {
    name: 'trade_deficit_1pmc',
    components: {
      VuePlotly,
    },
    props: [],
    computed: {
      ...mapGetters([
        'get_dsm_result',
        'historyPlotDataTotal',
        'getDsmAppState',
        'app_data',
        'single_product',
        'home_market_code',
      ]),
      plotData: function () {
        let plot_list = [
          {
            y: this.trade_deficit()['y'],
            x: this.trade_deficit()['x'],
            type: 'bar',
            marker: {
              color: this.trade_deficit()['colors'],
            },
          },
        ];

        return plot_list;
      },
      show: function () {
        // return this.$store.getters.historyPlotDataTotal['x'][0] > 1 ? true : false;
        return true;
      },
      layout: function () {
        return {
          title: {
            automargin: true,
            text: `Trade balance of ${this.single_product} <br>for ${this.codeToMarket(
              this.home_market_code ,
            )} ` +" ("+ this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.combinations.markets_count+ " selected markets)",
            font: {
              size: 10,
              color: 'black',
            },
            yref: 'container',
            x: 0.1,
            y: 0.94,
            yanchor: 'bottom',
            pad: {
              b: 10,
            },
          },
          height: '300',
          width: '350',
          autosize: true,
          margin: {
            l: 50,
            r: 20,
            b: 40,
            t: 60,
            pad: 2,
          },

          xaxis: {
            tickmode: 'linear',
            fixedrange: true,
            tickfont: {
              size: 10,
            },
          },
          yaxis: {
            title: '',
            rangemode: 'tozero',
            fixedrange: true,


            tickfont: {
              size: 10,
            },
              exponentformat:'none'
          },
          legend: {
            orientation: 'h',
            font: {size: 9},
            automargin: true,
          },
          annotations: [
            {
              x: '0.13',
              y: '1.06',
              xref: 'paper',
              yref: 'paper',
              xanchor: 'right',
              yanchor: 'bottom',
              text:
                this.app_data.value_mulitplier['prefix'] +
                ' ' +
                this.app_data.exchange_rate['Currency'].slice(0, 3),
              showarrow: false,
            },
            {
              xref: 'paper',
              yref: 'paper',
              x: 0.39,
              y: -0.1,
              xanchor: 'center',
              yanchor: 'top',
              text: config.CEPII_Source,
              showarrow: false,
              font: {
                family: 'Arial',
                size: 8,
                color: 'rgb(150,150,150)',
              },
            },
          ],
        };
      },
    },
    methods: {
      trade_deficit() {
        let deficit = this.array_value_conversion(
          this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.query_results[
            'dsm_history_total_world_sum'
          ].map(v => v['HM_ExportVal'] - v['HM_ImportVal']),
          'time_weighted',
        );

        let colors = [];
        deficit.forEach(v => {
          if (v >= 0) {
            colors.push(config.plot_bar_blue);
          } else {
            colors.push(config.plot_red);
          }
        });

        return {
          y: deficit,
          x: this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.query_results[
            'dsm_history_total_world_sum'
          ].map(v => v['T_Year']),
          colors: colors,
        };
      },
    },
    data: function () {
      return {
        options: {
          responsive: true,
          displayModeBar: false,
        },
      };
    },
  };
</script>
